import { render, staticRenderFns } from "./UpdateComposite.vue?vue&type=template&id=55d59e36&scoped=true&"
import script from "./UpdateComposite.vue?vue&type=script&lang=js&"
export * from "./UpdateComposite.vue?vue&type=script&lang=js&"
import style0 from "./UpdateComposite.vue?vue&type=style&index=0&id=55d59e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d59e36",
  null
  
)

export default component.exports